import type { JSX } from 'react';
import { Outlet, useLocation } from 'react-router';

import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { TooltipProvider } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';

const BackofficeLayout = (): JSX.Element => {
  const location = useLocation();
  const isDemoChatRoute = /\/project\/\d+\/demo-chat(?:\/|$|\?)/.test(location.pathname);
  const isTestingRoute = /\/project\/\d+\/testing(?:\/|$|\?)/.test(location.pathname);

  return (
    <TooltipProvider>
      <SidebarProvider className="h-svh max-h-svh min-h-0 overflow-hidden">
        <AppSidebar />
        <SidebarInset className="min-h-0 min-w-0 flex-1 overflow-hidden">
          <AppHeader />
          <div
            key={location.pathname}
            className={cn(
              'flex min-h-0 flex-1 min-w-0 flex-col p-8',
              isDemoChatRoute ? 'overflow-hidden' : 'overflow-auto',
              isTestingRoute && 'pb-0'
            )}
          >
            <Outlet />
          </div>
        </SidebarInset>
      </SidebarProvider>
    </TooltipProvider>
  );
};

export default BackofficeLayout;
